export default "__VITE_ASSET__0v9JmfSu__"